<template>
  <div>
    <v-row class="mt-4">
      <div>
        <span
          class="fs-medium mainFont--text"
          v-html="formattedDescription"
        ></span></div
    ></v-row>
  </div>
</template>

<script>
export default {
  name: "AuthorDescription",
  props: ["authorDetails"],
  computed: {
    formattedDescription() {
      return this.authorDetails.description
        ? this.authorDetails.description
            .replace(/\n/g, "<br>")
            .replace(/<a /g, '<a target="_self" ')
        : "";
    },
  },
};
</script>

<style lang="scss">
.ql-align-justify {
  text-align: justify;
}
</style>
